<template>
  <div>
    <h2 class="text-h3 mb-3">Source Articles</h2>
    <NewsTab :market="slug" :categories-articles="categoriesArticles" />

    <h2 class="text-h3 mb-3 mt-6">Price Analysis</h2>
    <PriceAnalysisTab
      :name="BLACK_MASS.name"
      :slug="BLACK_MASS.slug"
      :service-base-path="BLACK_MASS.serviceBasePath"
      :icon="BLACK_MASS.iconLine"
    />
  </div>
</template>

<script lang="ts" setup>
import { BLACK_MASS } from '~/constants/services/constants'
import PriceAnalysisTab from '~/components/market-insights/PriceAnalysisTab.vue'
import NewsTab from '~/components/market-insights/NewsTab.vue'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  slug: string
  categoriesArticles?: string[]
}>()
</script>
